// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--9264d";
export var entries = "styles-module--entries--15484";
export var list = "styles-module--list--2a480";
export var spinner = "styles-module--spinner--e2aaa";